<template>
  <el-dialog
    :title="$t('evBike.deleteBike')"
    :visible.sync="visible"
    width="400px">
    <div style="padding: 20px 0;">
      <p>{{ $t('evBike.confirmDelete') }}</p>
      <p style="color: #999; font-size: 12px; margin-top: 10px;">
        {{ $t('evBike.plateNumber') }}: {{ currentBike.plateNumber }}
      </p>
      <p style="color: #999; font-size: 12px; margin-top: 5px;">
        {{ $t('evBike.ownerName') }}: {{ currentBike.ownerName }}
      </p>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="danger" @click="confirmDelete" :loading="loading">
        {{ $t('common.delete') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { deleteEvBike } from '@/api/evbike/evBikeApi'

export default {
  name: 'DeleteEvBike',
  data() {
    return {
      visible: false,
      loading: false,
      currentBike: {},
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
  },
  methods: {
    open(bike) {
      this.currentBike = bike
      this.visible = true
    },

    async confirmDelete() {
      this.loading = true
      try {
        await deleteEvBike({
          bikeId: this.currentBike.bikeId,
          communityId: this.currentBike.communityId || this.communityId
        })

        this.$message.success(this.$t('common.deleteSuccess'))
        this.$emit('listEvBikeData')
        this.visible = false
      } catch (error) {
        console.error('删除电动车失败:', error)
        this.$message.error(error.message || this.$t('evBike.deleteError'))
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
